import { AppBadgesType } from './types';
export function isAppWithBenefits(appBadges) {
  const appWithBenefits = appBadges.find(_ref => {
    let {
      badge
    } = _ref;
    return badge === AppBadgesType.PREMIUM_BENEFIT || badge === AppBadgesType.APP_BENEFIT;
  });
  if ((appWithBenefits == null ? void 0 : appWithBenefits.badge) === 'PREMIUM_BENEFIT') {
    var _appWithBenefits$bund;
    return appWithBenefits != null && (_appWithBenefits$bund = appWithBenefits.bundleAppBadgePayload) != null && _appWithBenefits$bund.appBundleType ? true : false;
  } else if ((appWithBenefits == null ? void 0 : appWithBenefits.badge) === 'APP_BENEFIT') {
    return true;
  } else {
    return false;
  }
}
//# sourceMappingURL=is-app-with-benefit.js.map